<script setup lang="ts">
import { faSearch } from '@fortawesome/pro-light-svg-icons'

defineProps<{ mode: 'open' | 'close' }>()
</script>

<template>
  <ReadingMobileTableOfContentBar :mode="mode" view-key="academic-article-view-stack" open-label="Åpne innhold">
    <!-- Placeholder only since article search is not built yet. Avoid a disabled input because screen readers would announce it repeatedly. -->
    <div aria-hidden="true" class="flex-1 flex items-center justify-end h-11 px-s rounded-lg border border-border-default bg-surface-elevated opacity-60">
      <Icon :icon="faSearch" size="sm" class="text-secondary" />
    </div>
  </ReadingMobileTableOfContentBar>
</template>
